import lockupDark from "../images/insight-bw-dark.png";
import lockupWhite from "../images/insight-bw-white.png";
import { getTheme, type Theme } from "../theme";

// Betaworks-marken (vektor) — brukes til favicon-lignende sammenhenger + watermark.
export function BrandMark({ size = 26, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className}
      height={size}
      viewBox="0 0 377 578"
      fill="currentColor"
      role="img"
      aria-label="betaworks"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="translate(-5, -122)">
        <g transform="translate(4.7836, 121.8079)">
          <rect transform="translate(218.6103, 154) rotate(43) translate(-218.6103, -154)" x="59.1103258" y="93" width="319" height="122" rx="58" />
          <rect transform="translate(211.6103, 334) rotate(43) translate(-211.6103, -334)" x="52.1103258" y="273" width="319" height="122" rx="58" />
          <rect transform="translate(108.5, 468.5893) rotate(133) translate(-108.5, -468.5893)" x="16" y="407.589261" width="185" height="122" rx="58" />
        </g>
      </g>
    </svg>
  );
}

// Full «betaworks insight»-lockup. Bytter mellom hvit/mørk variant etter tema.
export function Brand({ height = 26, theme }: { height?: number; theme?: Theme }) {
  const t = theme ?? getTheme();
  return (
    <div className="brand">
      <img
        className="brand-logo"
        src={t === "dark" ? lockupWhite : lockupDark}
        alt="betaworks insight"
        style={{ height }}
      />
    </div>
  );
}
